import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ProcedimentoService } from 'src/app/procedimento/procedimento.service';
import { PrestadorService } from '../prestador.service';
import { Prestador } from 'src/app/shared/model/prestador.model';
import { PrestadorProcedimento } from 'src/app/shared/model/prestador-procedimento.model';
import { ToastrService } from 'ngx-toastr';

@Component({templateUrl: './prestador-procedimento.component.html', styleUrls: ['./prestador-procedimento.component.css']})
export class PrestadorProcedimentoComponent implements OnInit {

  prestador = new Prestador();
  prestProcedimento: PrestadorProcedimento;
  listaTodosProcedimentos = [];

  listaProcedimentosPorPrestador = [];
  codigosProcedimentos = Array<number>();
  identificadorPrestProcedimentoExclusao: number;

  constructor(config: NgbModalConfig, private modalService: NgbModal, private toast: ToastrService,
    private procedimentoService: ProcedimentoService, private router: Router, private activatedRoute: ActivatedRoute,
    private prestadorService: PrestadorService) {
      // customizar os valores default do modal.
      config.backdrop = 'static';
      config.keyboard = false;
    }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      const prestadorId = params['prestadorId'];

      this.getPrestador(prestadorId);
      this.buscarProcedimentosPorPrestador(prestadorId);
    });
  }

  /**
   * Método para buscar o valor unitário padrão do procedimento
   * @param procedimentoId identificador do procedimento selecionado pelo usuário.
   */
  changeProcedimentoValorUnitario(procedimentoId: any): void {
    this.listaTodosProcedimentos.filter(proc => {
      if (procedimentoId === proc.id) {
        this.prestProcedimento.valorUnitario = proc.valorUnitario;
      }
    });
  }

  /**
   * Método responsável por preparar o modal para cadastar um procedimento para o prestador.
   * @param content contéudo do modal
   */
  modalNovoPrestadorProcedimento(content) {
    // Inicializar o objeto toda vez que o modal for chamado
    this.prestProcedimento = new PrestadorProcedimento();

    this.modalService.open(content);
  }

  /**
   *  Método responsável para preparar o modal para alteração
   * @param content dados do modal
   * @param prestProcedimentoId identificador do procedimento associado ao prestador.
   */
  modalAlterarPrestadorProcedimento(content, prestProcedimentoId: number) {
    this.prestadorService.buscarProcedimentoPorPrestador(prestProcedimentoId).subscribe(
        (prestProcedimento) => {
          this.prestProcedimento = prestProcedimento;

          this.modalService.open(content);
        },
        (errror) => this.toast.error('Erro ao carregar os dados, tente novamente!')
    );
  }

  /**
   * Método responsável por montar o modal de confirmação da exclusão da associação.
   * @param content dados do template do modal.
   * @param prestProcedimentoId id da guia médica que o usuário selecionou.
   */
  modalExclusaoGuia(content, prestProcedimentoId) {
    this.identificadorPrestProcedimentoExclusao = prestProcedimentoId;

    this.modalService.open(content);
  }

  // Método usado para cadastrar/alterar um usuário
  save(form) {
    if (this.prestProcedimento.id) {
      this.prestadorService.associarProcedimento(this.prestProcedimento, this.prestador.id).subscribe(
          () => {
            this.toast.success('Procedimento atualizado com sucesso!');
            this.buscarProcedimentosPorPrestador(this.prestador.id);
          },
          (responseError) => this.toast.error('Erro ao associar o procedimento, tente novamente!'));
    } else {
      this.prestadorService.associarProcedimento(this.prestProcedimento, this.prestador.id).subscribe(
        () => {
          this.toast.success('Procedimento associado com sucesso!');

          this.buscarProcedimentosPorPrestador(this.prestador.id);

          // Resetar o form após confirmar
          form.reset();

          // Inicializar o objeto toda vez que for alterado.
          this.prestProcedimento = new PrestadorProcedimento();
        }, (responseError) => this.toast.error('Erro ao associar o procedimento, tente novamente!'));
    }
  }

  /**
   * Método responsável por excluir um procedimento associado ao prestador.
   * @param prestProcedimentoId identificador do procedimento associado ao prestador.
   */
  excluir(prestProcedimentoId: number) {
    this.prestadorService.deletarProcedimentoPorPrestador(prestProcedimentoId).subscribe(
      () => {
        this.toast.success('Associação excluída com sucesso!');
        this.buscarProcedimentosPorPrestador(this.prestador.id);
      },
      (responseError) => this.toast.error('Erro ao excluir, tente novamente!')
    );

    // Fechar o modal.
    this.modalService.dismissAll();
  }

  /**
   * Método responsável por buscar os procedimentos cadastrados para o prestador passado no parâmetro.
   * @param prestadorId identificador do prestador.
   */
  private buscarProcedimentosPorPrestador(prestadorId: number) {
    // Limpar a lista de códigos
    this.codigosProcedimentos = [];

    this.prestadorService.buscarProcedimentosPorPrestador(prestadorId).subscribe(
      (dados) => {
        this.listaProcedimentosPorPrestador = dados;

        // Guardar o id dos procedimentos na lista abaixo.
        this.listaProcedimentosPorPrestador.forEach(proc => this.codigosProcedimentos.push(proc.procedimentoId));

        // Buscar todos os procedimentos ativos.
        this.listarTodosProcedimentosAtivos();
      },
      errorResponse => this.toast.error(errorResponse.error.mensagemUsuario)
    );
  }

  // Método responsável por listar todos os procedimentos
  private listarTodosProcedimentosAtivos() {
    this.listaTodosProcedimentos = [];
    this.procedimentoService.listarTodosProcedimentosAtivos().subscribe(
      (dados) => {
        // Atribuir na lista dos procedimentos os que não estão cadastrados para esse prestador.
        dados.forEach(procedimento => {
          if (!this.codigosProcedimentos.includes(procedimento.id)) {
            this.listaTodosProcedimentos.push(procedimento);
          }
        });
      },
      (error) => this.toast.error(error.error.mensagemUsuario));
  }

 /**
   * Método responsável por buscar os dados do prestador.
   * @param prestadorId identificador do prestador
   */
  private getPrestador(prestadorId: number) {
    this.prestadorService.buscar(prestadorId).subscribe(
      (dados) => this.prestador = dados,
      (responseError) => {
        if (responseError instanceof HttpErrorResponse) {
          if (responseError.status === 404) {
            this.router.navigate(['/not-found']);
          } else if (responseError.status === 403) {
            this.router.navigate(['/nao-autorizado']);
          } else {
            this.toast.error('Ocorreu um erro ao processar a sua solicitação');
          }
        }
      }
    );
  }
}
